import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Popconfirm, Space, Table, Tag, message } from "antd";
import service from "../../api/FetchInterceptor";
import AddAvailability from "./add";
import dayjs from "dayjs";

const Availabilities = () => {
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [meta, setMeta] = useState({ total: 0, per_page: 10, current_page: 1 });
    const [open, setOpen] = useState(false);
    const [editId, setEditId] = useState(null);

    const load = (page = 1) => {
        setLoading(true);
        service({
            method: "GET",
            url: "admin/availabilities",
            params: { page },
        })
            .then((response) => {
                const data = response;

                const list = response.data

                setItems(list);

                const m = data.meta ?? data;
                setMeta({
                    total: Number(m.total ?? list.length),
                    per_page: Number(m.per_page ?? 10),
                    current_page: Number(m.current_page ?? page),
                });
            })
            .catch(() => message.error("Erreur de chargement"))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        load(1);
    }, []);

    const onAdd = () => {
        setEditId(null);
        setOpen(true);
    };

    const onEdit = (id) => {
        setEditId(id);
        setOpen(true);
    };

    const onDelete = (id) => {
        service({ method: "DELETE", url: `admin/availabilities/${id}` })
            .then((res) => {
                const data = res.data ?? res;
                message.success(data.message ?? "Supprimé");
                load(meta.current_page);
            })
            .catch(() => message.error("Erreur lors de la suppression"));
    };

    const columns = useMemo(
        () => [
            {
                title: "Date",
                dataIndex: "date",
                key: "date",
                render: (v) => dayjs(v).format('DD/MM/YYYY') ?? "-",
            },
            {
                title: "Créneau",
                key: "slot",
                render: (_, row) => (
                    <Tag>
                        {(row.start_time ?? "--:--")} - {(row.end_time ?? "--:--")}
                    </Tag>
                ),
            },
            {
                title: "Actions",
                key: "actions",
                width: 200,
                render: (_, row) => (
                    <Space>
                        <Button onClick={() => onEdit(row.id)}>Modifier</Button>

                        <Popconfirm
                            title="Supprimer cette disponibilité ?"
                            okText="Oui"
                            cancelText="Non"
                            onConfirm={() => onDelete(row.id)}
                        >
                            <Button danger>Supprimer</Button>
                        </Popconfirm>
                    </Space>
                ),
            },
        ],
        [meta.current_page]
    );

    return (
        <>
            <Card
                title="Disponibilités"
                extra={
                    <Button type="primary" onClick={onAdd}>
                        + Ajouter
                    </Button>
                }
            >
                <Table
                    rowKey="id"
                    loading={loading}
                    columns={columns}
                    dataSource={items}
                    pagination={{
                        current: meta.current_page,
                        pageSize: meta.per_page,
                        total: meta.total,
                        onChange: (p) => load(p),
                    }}
                />
            </Card>

            <AddAvailability
                id={editId}
                open={open}
                setOpen={setOpen}
                onSuccess={() => load(meta.current_page)}
            />
        </>
    );
};

export default Availabilities;
